module.exports = "<div class=\"d-flex flex-column align-items-center justify-content-center my-6\">\n  <div>\n    <img src=\"assets/img/loading.gif\" alt=\"\" width=\"100\" height=\"100\">\n  </div>\n  <div class=\"text-muted\">\n    <span i18n=\"@@loaderLC\">Loading...</span>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/loader/loader.component.html
// module id = ./src/app/shared/loader/loader.component.html
// module chunks = main